import { useIdleTimer } from "react-idle-timer";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import regenerateToken from "./regenerateToken";

const IdleComponent = (props) => {
  const [modal, setModal] = useState(false);
  const [logOutLoader, setLogOutLoader] = useState(false);
  const history = useHistory();
  const { Component, version, setEditVersion } = props;

  // Auto-refresh idToken every 50 minutes (before AWS Cognito's 1h expiry)
  // Also resets loginTimeStamp to keep the 8-hour session window alive
  useEffect(() => {
    const refreshInterval = setInterval(async () => {
      try {
        await regenerateToken();
        localStorage.setItem("loginTimeStamp", new Date().getTime());
        console.log("[Auth] Token silently refreshed at", new Date().toLocaleTimeString());
      } catch (e) {
        console.warn("[Auth] Silent token refresh failed:", e.message);
      }
    }, 50 * 60 * 1000); // every 50 minutes

    return () => clearInterval(refreshInterval);
  }, []);

  useEffect(() => {
    if (modal) {
      const timerID = setTimeout(() => {
        logOut();
      }, 1800000);
      return () => clearTimeout(timerID);
    }
  }, [modal]);

  const onIdle = () => {
    setModal(true);
    console.log("Timer will start");
  };

  const onActive = () => {
    // Bump loginTimeStamp whenever user is active so the 8-hour session window stays fresh
    localStorage.setItem("loginTimeStamp", new Date().getTime());
  };

  const { reset } = useIdleTimer({
    onIdle,
    onActive,
    timeout: 1800000,
  });

  const logOut = async () => {
    setLogOutLoader(true);
    // False loading
    setTimeout(() => {
      setLogOutLoader(false);
      setModal(false);
      localStorage.removeItem("credentials");
      localStorage.removeItem("loginTimeStamp");
      history.replace("/login");
    }, 1000);
  };

  const stayActive = () => {
    setModal(false);
    reset();
  };

  return (
    <>
      <Modal
        show={modal}
        animation={true}
        centered
        contentClassName="idle-modalCard"
        backdrop={"static"}
      >
        <div className="idle-container">
          <div className="d-flex">
            <img
              src="https://niroggyan.s3.ap-south-1.amazonaws.com/onboardingPortal/idle-exclamation.svg"
              alt="idle"
              style={{ height: "70px", marginRight: "25px" }}
            />
            <div className="d-flex flex-column">
              <h2 style={{ marginBottom: "8px" }}>
                Your session is about to expire
              </h2>
              <p style={{ marginTop: "0px" }}>
                You will be logged out in 30 minutes.
              </p>
            </div>
          </div>
          <div className="d-flex mt-4" style={{ marginLeft: "110px" }}>
            <button
              className="btn btn-primary "
              variant="secondary"
              onClick={() => {
                stayActive();
              }}
              style={{
                minWidth: "100px",
                minHeight: "40px",
              }}
            >
              Keep me Signed in
            </button>
            <button
              disabled={logOutLoader}
              style={{
                minWidth: "100px",
                minHeight: "40px",
              }}
              className="btn btn-danger mx-3"
              variant="secondary"
              onClick={() => {
                logOut();
              }}
            >
              {logOutLoader ? (
                <Spinner
                  style={{ height: "23px", width: "23px", marginTop: "2px" }}
                />
              ) : (
                "Log me Out"
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Component version={version} setEditVersion={setEditVersion} />
    </>
  );
};

export default IdleComponent;
